module.exports = "<div [hidden]=\"!isLoading\">\n  <!-- <mat-progress-spinner mode=\"indeterminate\" [strokeWidth]=\"2\" [diameter]=\"32 * size\"></mat-progress-spinner> -->\n  <img class=\"image\" src=\"assets/title19284996.png\" alt=\"\" width=\"60\" height=\"60\">\n\n  <span class=\"message\" *ngIf=\"message\">{{message}}</span>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.html
// module id = ./src/app/loader/loader.component.html
// module chunks = main